import { fetchConversations } from "./fetchConversations"

export const ACTIVATE_MANAGED_CONVERSATION_BEGIN   = "ACTIVATE_MANAGED_CONVERSATION_BEGIN"
export const ACTIVATE_MANAGED_CONVERSATION_SUCCESS = "ACTIVATE_MANAGED_CONVERSATION_SUCCESS"
export const ACTIVATE_MANAGED_CONVERSATION_FAILED  = "ACTIVATE_MANAGED_CONVERSATION_FAILED"

const activateManagedConversationBeginAction   =  (payload) => ({ type: ACTIVATE_MANAGED_CONVERSATION_BEGIN, payload })
const activateManagedConversationSuccessAction =  (payload) => ({ type: ACTIVATE_MANAGED_CONVERSATION_SUCCESS, payload })
const activateManagedConversationBeginFailed   =  (payload) => ({ type: ACTIVATE_MANAGED_CONVERSATION_FAILED, payload })

export const activateManagedConversation = (data) => {
  return (dispatch) => {
    dispatch(activateManagedConversationBeginAction())
    return $.ajax({
      url: `/api/staff/v1/conversations/enable_group_chat.json`,
      method: 'POST',
      data
    }).then((response)=>{
      dispatch(activateManagedConversationSuccessAction(response))
      dispatch(fetchConversations(true, false)).then(()=>dispatch(setCurrentConversation(response)))
    })
  }
}